import React from 'react';
import './rider-policy.css';
import logo from './logo.png';
import bannerBg from '../../../assets/images/banner.jpg';

const RiderPolicy = () => (
        <div 
            className="rider-policy-wrapper"
            style={{ 
                backgroundImage: `url(${bannerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                minHeight: '100vh',
                position: 'relative',
                paddingTop: '150px',
                paddingBottom: '80px'
            }}
        >
            {/* Dark overlay to make content pop */}
            <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.65)',
                zIndex: 0
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="card glass-card text-white" style={{ background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '15px', padding: '30px 20px' }}>
                    <div className="header text-center mb-4">
                        <img src={logo} alt="Droppzy Logo" className="logo mb-3" style={{ maxWidth: '150px' }} />
                        <h1 className="text-white">Privacy Policy</h1>
                        <p className="updated text-white">
                            Droppzy Driver App<br/>
                            Last Updated: June 9, 2026
                        </p>
                    </div>
                    <p>
                        This Privacy Policy describes how Droppzy ("we", "our", or "us")
                        collects, uses, protects, and shares your personal information
                        when you use the Droppzy Driver mobile application ("App")
                        and related services.
                    </p>
                    <p>
                        By using the Droppzy Driver App, you agree to the collection
                        and use of information in accordance with this Privacy Policy.
                    </p>
                    <h2>1. Information We Collect</h2>
                    <h3>A. Information You Provide to Us</h3>
                    <ul>
                        <li>
                            <strong>Account Information:</strong>
                            Name, email address, phone number, and profile picture.
                        </li>
                        <li>
                            <strong>Verification Documents:</strong>
                            Driver's license, vehicle registration,
                            insurance information, and eligibility verification data.
                        </li>
                        <li>
                            <strong>Payment Information:</strong>
                            Bank account details and payout information
                            necessary to process earnings.
                        </li>
                    </ul>
                    <h3>B. Information Collected Automatically</h3>
                    <ul>
                        <li>
                            <strong>Location Data:</strong>
                            Precise and approximate location information while
                            the app is running in foreground or background.
                        </li>
                        <li>
                            <strong>Usage Data:</strong>
                            App interactions, access times, crash reports,
                            diagnostics, and system activity.
                        </li>
                        <li>
                            <strong>Device Information:</strong>
                            Device model, operating system version,
                            unique identifiers, and mobile network information.
                        </li>
                    </ul>
                    <div className="highlight">
                        <strong>Important:</strong>
                        Location tracking is a core feature of Droppzy Driver and is
                        required for order assignment, route optimization,
                        real-time tracking, and delivery management.
                    </div>
                    <h2>2. How We Use Your Information</h2>
                    <ul>
                        <li>Provide delivery and logistics services.</li>
                        <li>Connect drivers with delivery requests.</li>
                        <li>Process driver earnings and payouts.</li>
                        <li>Verify identity and prevent fraud.</li>
                        <li>Provide customer and technical support.</li>
                        <li>Improve app performance and user experience.</li>
                        <li>Maintain platform safety and security.</li>
                    </ul>
                    <h2>3. How We Share Your Information</h2>
                    <ul>
                        <li>
                            <strong>Customers & Merchants:</strong>
                            During active deliveries, limited information such as
                            first name, profile picture, vehicle type, and live location.
                        </li>
                        <li>
                            <strong>Service Providers:</strong>
                            Payment processors, cloud hosting providers,
                            analytics services, and verification providers.
                        </li>
                        <li>
                            <strong>Legal Compliance:</strong>
                            When required by law, legal process,
                            or governmental requests.
                        </li>
                        <li>
                            <strong>Business Transfers:</strong>
                            In connection with mergers, acquisitions,
                            or asset transfers.
                        </li>
                    </ul>
                    <h2>4. Location Tracking & Background Processing</h2>
                    <p>
                        Droppzy Driver requires background location access
                        to provide delivery dispatching and real-time logistics services.
                    </p>
                    <ul>
                        <li>Location is tracked while marked as "Online".</li>
                        <li>Location tracking stops when marked as "Offline".</li>
                        <li>
                            Disabling location permissions may limit
                            or prevent app functionality.
                        </li>
                    </ul>
                    <h2>5. Data Retention & Deletion</h2>
                    <p>
                        We retain information for as long as necessary
                        to provide services, comply with legal obligations,
                        resolve disputes, and enforce agreements.
                    </p>
                    <p>
                        Drivers may request account deletion by contacting support.
                        Certain information may be retained when required
                        by applicable laws and regulations.
                    </p>
                    <h2>6. Security of Your Information</h2>
                    <p>
                        We implement administrative, technical, and physical safeguards
                        designed to protect your personal information. However,
                        no transmission method or electronic storage system can
                        be guaranteed to be 100% secure.
                    </p>
                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time.
                        Updates will be posted on this page with a revised
                        "Last Updated" date.
                    </p>
                    <h2>8. Contact Us</h2>
                    <div className="contact-box">
                        <p><strong>Droppzy Driver Support</strong></p>
                        <p>Email: support@droppzy.com</p>
                        <p>Website: https://www.droppzy.com</p>
                    </div>
                    <div className="footer">
                        © 2026 Droppzy Driver. All Rights Reserved.
                    </div>
                </div>
            </div>
        </div>
);

export default RiderPolicy;
